import React, { memo, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { translate } from 'react-i18next';

import { Col } from 'react-bootstrap';
import { colorFix, replaceAll } from 'utils';

import * as _ from 'lodash';

import OverviewStock from './layout/bieu-do/layout/overviewStock';
import OverviewVNIndex from './layout/bieu-do/layout/overviewVNI';

import {
  makeGetAnalStockReal,
  makeGetSecAllList,
  makeGetToken,
} from 'lib/selector';
import { _indexList } from 'utils/config';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function TabAnalysisChart(props) {
  const frameRef = useRef(null);

  const [symActive, setSymActive] = React.useState(null);

  const { symbol, secListAll, analStReal, t, lang, theme, token } = props;

  const preSymbol = usePrevious(symbol);
  const preSymActive = usePrevious(symActive);

  useEffect(() => {
    window.addEventListener('message', handlerMessage);
    setSymActive(symbol);
    // clean up
    return () => window.removeEventListener('message', handlerMessage);
  }, []);

  useEffect(() => {
    if (symbol && symbol !== preSymbol) {
      // log(symbol, preSymbol);
      setSymActive(symbol);
    }
  }, [symbol]);

  useEffect(() => {
    if (symActive && symActive !== preSymActive) {
      sendMessage(symActive);
    }
  }, [symActive]);

  // send message to frame chart
  const sendMessage = (sym) => {
    // log('send message to frame chart');
    if (frameRef && frameRef.current && frameRef.current.contentWindow) {
      const _data = { symbolChart: sym };
      frameRef.current.contentWindow.postMessage(JSON.stringify(_data), '*');
    }
  };

  function handlerMessage(event) {
    try {
      const data = event.data;
      // log('message from frame', data);
      if (data && data.startsWith('#CHANGESYM#')) {
        const _newSym = replaceAll(data, '#CHANGESYM#', '');
        // log(_newSym);
        setSymActive(_newSym);
      }
    } catch (error) {
      // log(error)
    }
  }

  const _stock =
    symActive &&
    secListAll &&
    !_.some(_indexList, (o) => o === symActive) &&
    secListAll[symActive];

  // console.log(secListAll);

  return (
    <div
      className="d-flex flex-row w-100"
      style={{ height: 'calc(100vh - 95px)' }}
    >
      <Col className="p-0 d-flex flex-column">
        {symActive && !_.some(_indexList, (o) => o === symActive) && (
          <div className="analysis-sym-header">
            <span className="analysis-sym-item">{`${_stock}`}</span>
            <span
              className={
                'analysis-sym-item-detail ' +
                colorFix(
                  analStReal?.FinishPrice,
                  analStReal?.RefPrice,
                  analStReal?.CeilingPrice,
                  analStReal?.FloorPrice,
                  analStReal?.RefPrice
                )
              }
            >{`${analStReal?.FinishPrice} (${analStReal?.Diff} ${analStReal?.DiffRate}%)`}</span>
          </div>
        )}
        <iframe
          ref={frameRef}
          title="chart"
          src={
            '/chartTVS/?resolution=D&symbol=VNINDEX&lang=' +
            lang +
            '&theme=' +
            theme +
            (token ? `&u=${token?.user}` : '')
          }
          scrolling="no"
          style={{ height: '100%' }}
        ></iframe>
      </Col>
      <div style={{ width: '315px' }} className="ml-2">
        {_.some(_indexList, (o) => o === symActive) ? (
          <OverviewVNIndex symActive={symActive} t={t} theme={theme} />
        ) : (
          <OverviewStock symActive={symActive} t={t} theme={theme} />
        )}
      </div>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getSecAllList = makeGetSecAllList();
  const getAnalStockReal = makeGetAnalStockReal();
  const getToken = makeGetToken();
  // const getAnalPBDongTien = makeGetAnalPBDongTien();

  const mapStateToProps = (state) => {
    return {
      secListAll: getSecAllList(state),
      analStReal: getAnalStockReal(state),
      lang: state.client?.setting?.lang || 'vi',
      theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
      token: getToken(state),
      // analPBDongTien: getAnalPBDongTien(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(memo(TabAnalysisChart))
);
